module.exports = __webpack_public_path__ + "static/media/deskAndChalkboardTransparent.89a4950e.png";